import { render, staticRenderFns } from "./StorageFiles.vue?vue&type=template&id=634cff47"
import script from "./StorageFiles.vue?vue&type=script&lang=js"
export * from "./StorageFiles.vue?vue&type=script&lang=js"
import style0 from "./StorageFiles.vue?vue&type=style&index=0&id=634cff47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports